import React, { useEffect, useState } from "react";
import { Tab, Tabs, Box, LinearProgress } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import ListActivities from "./components/ListActivities";
import { API_get_activities_not_hide, API_get_bookings_id } from "./utils/http";
import { useTasks, useTasksDispatch } from "./AppContext";
import InputLeftInfo from "./components/InputLeftInfo";
import InputLeftPrice from "./components/InputLeftPrice";
import ListAccom from "./components/ListAccom";
import InputLeftTax from "./components/InputLeftTax";
import InputLeftPriceSheet from "./components/InputLeftPriceSheet";
import { dispatchTYPE } from "./utils/constDispatch";
import { checkOper_or_admin } from "./utils/tool";
import OperDetail from "./components/operating/OperDetail";
import TabPDFDraft from "./components/pdf/TabPDFDraft";

export default function InputLeft({ booking_id }) {
  const data_pdf = useTasks();
  const dispatch = useTasksDispatch();

  const [accommondation, set_accommondation] = useState(null);
  const [activities, set_activities] = useState(null);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const uniqueByProperty = (arr, key) => {
    return arr.filter(
      (obj, index, self) =>
        index === self.findIndex((t) => t[key] === obj[key]),
    );
  };

  const findDuplicatesByProperty = (arr, key) => {
    const counts = new Map();
    const duplicates = [];

    arr.forEach((obj) => {
      const value = obj[key];
      counts.set(value, (counts.get(value) || 0) + 1);
    });

    arr.forEach((obj) => {
      if (counts.get(obj[key]) > 1) {
        duplicates.push(obj);
      }
    });

    return [...new Set(duplicates)]; // Remove duplicate duplicate objects if any
  };

  async function get_data_activities_accom() {
    API_get_activities_not_hide((data) => {
      // console.log(data.data.length);

      let new_acti = data.data.map((v) => ({ ...v, key: v._id }));
      let new_acti_uniqueData = uniqueByProperty(new_acti, "label");

      // let new_acti_duplicate = findDuplicatesByProperty(new_acti, "label");
      // console.log(new_acti_duplicate);

      // console.log(new_acti_uniqueData.length);
      set_activities(new_acti_uniqueData);
      set_accommondation(data.accom);
    });
  }

  async function get_data() {
    API_get_bookings_id(booking_id, (x) => {
      if (x.success) {
        let data = x.data;
        dispatch({
          type: dispatchTYPE.get_data_pdf,
          value: data,
        });
      }
    });
  }

  useEffect(() => {
    get_data_activities_accom();

    get_data();
  }, []);

  if (accommondation != null && data_pdf != null) {
    return (
      <Box sx={{ height: "100%" }}>
        <Box
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              minHeight: 38,
              "& .MuiTab-root": {
                minHeight: 38,
                fontSize: "0.72rem",
                padding: "6px 10px",
                minWidth: "auto",
              },
              "& .MuiTab-root .MuiSvgIcon-root": {
                fontSize: "1rem",
                marginRight: "4px",
              },
            }}
          >
            <Tab icon={<InfoOutlinedIcon />} iconPosition="start" label="Info" />
            <Tab
              icon={<DirectionsWalkIcon />}
              iconPosition="start"
              label="Actv"
            />
            <Tab
              icon={<HotelOutlinedIcon />}
              iconPosition="start"
              label="Accom"
            />
            <Tab icon={<PaidOutlinedIcon />} iconPosition="start" label="Price" />
            <Tab
              icon={<CalculateOutlinedIcon />}
              iconPosition="start"
              label="Calc"
            />
            {checkOper_or_admin() ? (
              <Tab
                icon={<ReceiptLongOutlinedIcon />}
                iconPosition="start"
                label="TAX"
              />
            ) : null}
            {checkOper_or_admin() ? (
              <Tab
                icon={<ListAltOutlinedIcon />}
                iconPosition="start"
                label="price list"
              />
            ) : null}
            {checkOper_or_admin() ? (
              <Tab
                icon={<DescriptionOutlinedIcon />}
                iconPosition="start"
                label="Draft"
              />
            ) : null}
          </Tabs>

          <Box style={{ flex: 1, position: "relative", overflow: "hidden" }}>
            <Box
              style={{
                padding: 10,
                height: "100%",
                overflow: "auto",
                paddingBottom: "0px",
              }}
            >
              {value == 0 ? <InputLeftInfo booking_id={booking_id} /> : null}
              {value == 1 ? (
                <ListActivities
                  accommondation={accommondation}
                  activities={activities}
                  booking_id={booking_id}
                />
              ) : null}
              {value == 2 ? (
                <ListAccom
                  accommondation={accommondation}
                  booking_id={booking_id}
                />
              ) : null}
              {value == 3 ? <InputLeftPrice /> : null}
              {/* Kept mounted (hidden when inactive) so unsaved Calc edits
                  survive tab switches. */}
              <div style={{ display: value == 4 ? "block" : "none" }}>
                <InputLeftPriceSheet
                  booking_id={booking_id}
                  active={value == 4}
                />
              </div>
              {value == 5 ? (
                <InputLeftTax booking_id={booking_id} data_pdf={data_pdf} />
              ) : null}
              {value == 6 ? <OperDetail booking_id={booking_id} /> : null}
              {value == 7 ? (
                <Box
                  sx={{
                    display: "flex",
                    height: "100%",
                    flexDirection: "column",
                  }}
                >
                  <TabPDFDraft data_pdf={data_pdf} />
                </Box>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  }
}
